import { graphql } from "@/gql";

export const tripByCities = graphql(`
  query TripByCities($cityAId: ID!, $cityBId: ID!) {
    tripByCities(cityAId: $cityAId, cityBId: $cityBId) {
      id
      __typename
      distance_kms
      duration_hrs
      route_name
      cityB {
        id
        name
        lat
        lng
      }
      cityA {
        id
        name
        lat
        lng
      }
    }
  }
`);
